import { LocationState } from "@/vuex/modules/locations/locations.types";

export const state: LocationState = {
  locations: [],
  loading: false,
  pagination: null,
  currentLocation: null,
  users: [],
  disabledMode: false
};
